<template>
    <div :id="local_la['footer']">
        <div class="company-info" :key="showHead">
            <div class="contact-us">
                <div class="contact-content">
                    <span class="footer-title footer-title-1">{{ local_la['联系我们'] }}</span>
                    <div class="content-1 content-first">
                        <div class="pict-box">
                            <img src="../../static/img/ic_email.png" alt="adress" class="pict">
                        </div>
                        <span class="footer-span footer-span-1">jccontact@gmail.com</span>
                    </div>
                    <!-- <div class="content-1">
                        <div class="pict-box">
                            <img src="../../static/img/ic_tel.png" alt="" class="pict">
                        </div>
                        <span class="footer-span footer-span-1">{{ local_la['联系电话: 13163308542'] }}</span>
                    </div> -->
                    <div class="content-1">
                        <div class="pict-box">
                            <img src="../../static/img/ic_adress.png" alt="" class="pict">
                        </div>
                        <span class="footer-span footer-span-1">{{ local_la['武汉东湖新技术开发区关南科技工业园现代国际设计城三期10号研发楼5层'] }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="hr-box">
            <div class="hr-line"></div>
        </div>
        <div class="company-last-info">
            <span>{{ local_la['武汉骄创科技有限公司旗下出品 | 科技赋能，为企业降低运营成本'] }}</span>
            <br>
            <span>{{ local_la['Copyright © 2021 武汉骄创科技有限公司  鄂ICP备2021032132号'] }}</span>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            ZH_la: {
                "logoSrcFooter": "../../static/img/pc_logocn_top.png",
                "关于我们": "关于我们",
                "武汉骄创科技有限公司旗下出品": "武汉骄创科技有限公司旗下出品",
                "科技赋能，为企业降低运营成本": "科技赋能，为企业降低运营成本",
                "联系我们": "联系我们",
                "联系电话: 13163308542": "联系电话: 13163308542",
                "武汉东湖新技术开发区关南科技工业园现代国际设计城三期10号研发楼5层": "武汉东湖新技术开发区关南科技工业园现代国际设计城三期10号研发楼5层",
                "Copyright © 2021 武汉骄创科技有限公司  鄂ICP备2021032132号": "Copyright © 2021 武汉骄创科技有限公司  鄂ICP备2021032132号",
                "武汉骄创科技有限公司旗下出品 | 科技赋能，为企业降低运营成本": "武汉骄创科技有限公司旗下出品 | 科技赋能，为企业降低运营成本",
                "footer": "footer-cn",
            },
            EN_la: {
                "logoSrcFooter": "../../static/img/pc_logoen_top.png",
                "关于我们": "About Us",
                "武汉骄创科技有限公司旗下出品": "By Wuhan Jiaochuang Technology Co., Ltd.",
                "科技赋能，为企业降低运营成本": "Enabling technology to reduce operating costs for enterprises",
                "联系我们": "Contact Us",
                "联系电话: 13163308542": "Tel:13163308542",
                "武汉东湖新技术开发区关南科技工业园现代国际设计城三期10号研发楼5层": "5th Floor, R&D Building, No. 10, Phase III, Modern International Design City, Guannan Science and Technology Industrial Park, Donghu New Technology Development Zone, Wuhan",
                "Copyright © 2021 武汉骄创科技有限公司  鄂ICP备2021032132号": "Copyright © 2021 Wuhan Jiaochuang Technology Co., Ltd. 鄂ICP备2021032132号",
                "武汉骄创科技有限公司旗下出品 | 科技赋能，为企业降低运营成本": "By Wuhan Jiaochuang Technology Co., Ltd. Enabling technology to reduce operating costs for enterprises",
                "footer": "footer",
            },
            local_la: {

            },
        }
    },
    created(){
        this.changeFooter()
    },
    methods: {
        changeFooter: function(){
            // 根据local_la确定字符串和图片的显示
            if (this.$store.state.languageState == false){
                this.local_la = this.ZH_la;
            } else {
                this.local_la = this.EN_la;
            }
        },
    },
    computed: {
        showHead: function() {
            this.changeFooter();
            return this.$store.state.languageState;
        }
    },
}
</script>

<style scoped>
#footer{
    width: 100%;
	height: 70vw;
	background-color: #0b0f1a;
}
#footer-cn{
    width: 100%;
	height: 50vw;
	background-color: #0b0f1a;
}
.company-info{
    padding-top: 4.48vw;
    display: flex;
    align-content: flex-start;
    justify-content: flex-start;
    margin-left: 4.72vw;
}
.contact-content{
    width: 90vw;
}
.logo-box{
    display: flex;
    align-content: center;
    justify-content: center;
}
.logo-content{
    width: 8.85vw;
	height: auto;
}
.content-1{
    display: flex;
    align-items: baseline;
    justify-content: flex-start;
}
.content-first{
    margin-top: 1.18vw;
}
.pict-box{
    margin-top: 0.2vw;
    width: 2.57vw;
	height: auto;
}
.about-content{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}
.footer-title{
	/* width: 13.06vw; */
	height: 1.15rem;
	/*  */
    font-weight: bolder;
	/* font-size: 3.33vw; */
    font-size: 1.25rem;
	/* font-weight: normal; */
	font-stretch: normal;
	line-height: 3.7vw;
	letter-spacing: 0vw;
	color: #ffffff;
}
.footer-span{
    width: 84.72vw;
	height: 13.52vw;
	/* font-size: 2.59vw; */
    font-size: 0.75rem;
	font-weight: normal;
	font-stretch: normal;
	line-height: 4.56vw;
	letter-spacing: 0vw;
	color: #888e9f;
}
.footer-span-1{
    /* width: 90.72vw; */
    margin-top: 0.5vw;
    margin-left: 1vw;
	height: auto;
}
.pict{
    width: 100%;
    height: auto;
}
.footer-title-1{
    margin-bottom: 3.18vw;
}
.hr-box{
    margin-top: 3.17vw;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    margin-left: 4.72vw;
}
.hr-line{
    width: 90vw;
	height: 0.05vw;
	background-color: #ffffff;
	opacity: 0.1;
}
.company-last-info{
    /* width: 100%; */
    margin-top: 0.59vw;
	
    font-size: 0.75rem;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0vw;
	color: #888e9f;
    margin-left: 4.72vw;
    padding-bottom: 2vw;
}
</style>


// WEBPACK FOOTER //
// src/components/H5Footer.vue